import type { IconData } from '@stacksjs/iconify-core'

export const caoDaiFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M29.056 5.565a6.057 6.057 0 0 0-10.112 0c-4.174 6.163-11.034 17.008-16.85 29.6c-1.74 3.77.599 8.1 4.797 8.532c3.937.405 9.696.803 17.11.803c7.412 0 13.171-.398 17.108-.803c4.199-.431 6.538-4.762 4.797-8.531c-5.815-12.593-12.675-23.438-16.85-29.6Z\"/><path fill=\"#2859c5\" d=\"M36.182 28.395a2.6 2.6 0 0 0 0-2.79C33.22 20.945 28.86 18 23.999 18s-9.221 2.945-12.183 7.605a2.6 2.6 0 0 0 0 2.79C14.778 33.055 19.138 36 24 36s9.221-2.945 12.183-7.605Z\"/><path fill=\"#8fbffa\" d=\"M29 27a5 5 0 1 0-10 0a5 5 0 0 0 10 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default caoDaiFlat
